import { Digits } from 'shared/enums/digits';

export const getBaseURL = (url: string) => {
    return url + '/api/public/';
};

export const stringIsNumber = (value) => isNaN(Number(value)) === false;

// Turn enum into array
export const enumToArray = (enumeration) => {
    return Object.keys(enumeration)
        .filter(stringIsNumber)
        .map((key) => enumeration[key]);
};

export const replaceAll = (str, oldChar, newChar) => {
    const regex = new RegExp(`${oldChar}`, 'g');
    return str?.replace(regex, newChar);
};

export const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        // Generate a random index from 0 to i
        const j = Math.floor(Math.random() * (i + 1));

        // Swap elements at i and j
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

export const truncateNumber = (value: number, decimals = 2) => {
    // This will truncate number and will keep only 2 digits after decimal point
    // Example: 100.5987 will become 100.59
    return !!value && !isNaN(value)
        ? Number(value?.toString()?.match(/^-?\d+(?:\.\d{0,2})?/)).toFixed(decimals)
        : Digits.Zero.toFixed(decimals);
};
